__turbopack_context__.v({
  "compartilhe": "xfVdYW_compartilhe",
  "iconTwitter": "xfVdYW_iconTwitter",
  "navSocial": "xfVdYW_navSocial",
});
